export default {
    data() {
        return {
            formatList: [
                '45',
                'LP',
                '12',
                'CD',
                'CD Single',
                'Cassette',
                'Cassette Single',
                '78',
            ]
        }
    }
}